import { Col, DatePicker, Form, Input, Radio, Row } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import useFetchSelect from 'elements/Hooks/useFetchSelect'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import React, { Fragment } from 'react'

import { compose } from 'recompose'
import { BUDGET_TYPE_SALES } from '../../../../components/Common/Budgets/BudgetCont'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import RegisteredPartnerDetails from '../../../../elements/RegisteredPartnerDetails'
import CurrencySelect from '../../../../elements/Select/Currency'
import CustomCascader from '../../../../elements/Select/CustomCascader'
import GroupsSelect from '../../../../elements/Select/Groups/GroupsSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withData from '../../../../elements/Select/withData'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal, formatQueryParams, strVal } from '../../../../modules/Utils'

const { TextArea } = Input

function RequisitionsForm(props) {
  let { requisition, saleOrderID } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form

  saleOrderID = getFieldValue('sales._id') || get(requisition, 'sales._id') || saleOrderID

  const { data, fetching, fetch: fetchURL } = useFetch({ url: `dropdowns/requisitions/orderType` })
  const OrderTypeSelect = compose(
    withSpinning,
    withData({
      data: data,
      fetch: fetchURL,
      fetching: fetching,
    })
  )(CustomCascader)

  const { data: sales } = useFetch({
    url: saleOrderID,
    dependencyArray: [saleOrderID],
    dontFetch: isEmpty(saleOrderID),
  })

  //contract listing
  const company = getFieldValue('company._id') || ''

  // sales order Selecting
  const contract = getFieldValue('contract._id')
  const salesOrdersUrl = `sales/?select=*${formatQueryParams('contract', contract)}&status=Approved`

  const { SelectData: SalesOrderSelect } = useFetchSelect({
    url: salesOrdersUrl,
    dependencyArray: [salesOrdersUrl],
    dontFetch: isEmpty(contract),
    mapFunction: (c) => ({
      ...c,
      display: `[${c.code}]  ${c.title}`,
    }),
  })

  const budgetUrl = `budgets/?select=*${formatQueryParams('contract', contract)}${formatQueryParams(
    'company',
    getFieldValue('company._id')
  )}&status=Approved&dropdown=true${formatQueryParams('budgetType', getFieldValue('budget.budgetType'))}`
  const { SelectData: BudgetSelect } = useFetchSelect({
    url: budgetUrl,
    dependencyArray: [budgetUrl],
    mapFunction: (b) => ({
      ...b,
      display: b.budgetType === BUDGET_TYPE_SALES ? `[${strVal(b, 'contract.code')}] ${b.title}` : b.title,
    }),
  })

  const { SelectData: CompanyRepSelect } = useFetchSelect({
    url: `members/${company.replace('members/', '')}/representatives`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const vendor = getFieldValue('vendor._id') || ''
  const { SelectData: ClientRepSelect } = useFetchSelect({
    url: `members/${vendor.replace('members/', '')}/representatives`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
  })

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Budget Type">
            {getFieldDecorator('budget.budgetType', {
              initialValue: get(requisition, 'budget.budgetType') || (saleOrderID ? 'Sales' : 'Internal'),
            })(
              <Radio.Group>
                <Radio.Button value="Internal">Internal</Radio.Button>
                <Radio.Button value="Sales">Sales</Radio.Button>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Order Type">
            {getFieldDecorator('orderType', {
              initialValue: get(requisition, 'orderType', []),
              rules: rules.input,
            })(<OrderTypeSelect keyAtr={'value'} valueAtr={'label'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {getFieldValue('budget.budgetType') === 'Sales' && (
          <Fragment>
            <RegisteredPartnerDetails
              doc={{
                ...requisition,
                'company._id': get(requisition, 'company._id') || get(sales, 'company._id'),
                'companyRep._id': get(requisition, 'companyRep._id') || get(sales, 'companyRep._id'),
                'client._id': get(requisition, 'client._id') || get(sales, 'client._id'),
                'clientRep._id': get(requisition, 'clientRep._id') || get(sales, 'clientRep._id'),
                'contract._id': get(requisition, 'contract._id') || get(sales, 'contract._id'),
              }}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'requisitions',
                showProfit: false,
              }}
            />
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Sales Order'}>
                {getFieldDecorator('sales._id', {
                  initialValue: get(requisition, 'sales._id') || saleOrderID,
                  rules: rules.select,
                })(<SalesOrderSelect keyAtr={'_id'} valueAtr={'display'} disabled={!getFieldValue('contract._id')} />)}
              </Form.Item>
            </Col>
          </Fragment>
        )}

        {getFieldValue('budget.budgetType') === 'Internal' && (
          <Fragment>
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Company">
                  {getFieldDecorator('company._id', {
                    initialValue: get(requisition, 'company._id'),
                    rules: rules.select,
                  })(<OrganisationsSelect />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Company Rep">
                  {getFieldDecorator('companyRep._id', {
                    initialValue: get(requisition, 'companyRep._id'),
                    rules: rules.select,
                  })(
                    <CompanyRepSelect
                      placeholder="Received By"
                      keyAtr={'_id'}
                      valueAtr={'name'}
                      style={{ width: '100%' }}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              {getFieldValue('orderType[1]') === 'Stock Release Order' && (
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Stock Holder">
                    {getFieldDecorator('client._id', {
                      initialValue: get(requisition, 'client._id'),
                      rules: rules.select,
                    })(<OrganisationsSelect />)}
                  </Form.Item>
                </Col>
              )}
              <Col span={12}>
                {vendor && (
                  <Form.Item {...defaultFormItemLayout} label="Stock Holder Rep">
                    {getFieldDecorator('clientRep._id', {
                      initialValue: get(requisition, 'clientRep._id'),
                      rules: rules.select,
                    })(
                      <ClientRepSelect
                        placeholder="Received By"
                        keyAtr={'_id'}
                        valueAtr={'name'}
                        style={{ width: '100%' }}
                      />
                    )}
                  </Form.Item>
                )}
              </Col>
            </Row>

            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Department">
                {getFieldDecorator('group._id', {
                  initialValue: get(requisition, 'group._id'),
                  rules: rules.select,
                })(<GroupsSelect />)}
              </Form.Item>
            </Col>
          </Fragment>
        )}

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Requisition Date">
            {getFieldDecorator('date', {
              initialValue: dateVal(requisition, 'date') || moment(),
              rules: rules.select,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Select a Budget">
            {getFieldDecorator('budget._id', {
              initialValue: get(requisition, 'budget._id') || strVal(sales, 'budget._id'),
              rules: rules.select,
            })(<BudgetSelect data-testid={'budget'} keyAtr={'_id'} valueAtr={'display'} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(requisition, 'title') || get(sales, 'title'),
              rules: rules.input,
            })(<Input data-testid="title" placeholder={'Title'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Currency'}>
            {getFieldDecorator('currency', {
              initialValue: get(requisition, 'currency') || get(sales, 'currency'),
              rules: rules.select,
            })(<CurrencySelect />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: get(requisition, 'description'),
            })(<TextArea rows={10} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

RequisitionsForm.propTypes = {}
RequisitionsForm.defaultProps = {}

export default Form.create()(RequisitionsForm)
